import { useUserProfile } from '~/shared/contexts';
import { hasProfileAccess, UserProfileType } from '~/shared/types/profile';

/**
 * Hook para verificar permissões baseadas no perfil do usuário
 */
export function useProfilePermissions() {
  const { profile, isLoading, error } = useUserProfile();

  const hasAccess = (allowedProfiles: UserProfileType[]) => {
    return hasProfileAccess(profile, allowedProfiles);
  };

  const isAdministrator = () => profile?.profileType === 'Administrator';
  const isZoneSpoc = () => profile?.profileType === 'Zone Spoc';
  const isCommonUser = () => profile?.profileType === 'Common User';

  // Verificações específicas para rotas/features
  const canAccessAdminFeatures = () => hasAccess(['Administrator']);
  const canAccessZoneFeatures = () => hasAccess(['Administrator', 'Zone Spoc']);
  const canAccessBasicFeatures = () =>
    hasAccess(['Administrator', 'Zone Spoc', 'Common User']);

  return {
    profile,
    profileType: profile?.profileType,
    isLoading,
    error,
    // Métodos de verificação
    hasAccess,
    isAdministrator,
    isZoneSpoc,
    isCommonUser,
    // Métodos de conveniência para features
    canAccessAdminFeatures,
    canAccessZoneFeatures,
    canAccessBasicFeatures
  };
}
